"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const compact_1 = __importDefault(require("lodash/compact"));
const defaultKey = ['talent-comparison'];
const keys = {
    default: defaultKey,
    comparisonBehaviorAssesments: (behaviorType, targetType, targetId, params) => {
        return (0, compact_1.default)([
            ...defaultKey,
            'behavior',
            targetId,
            targetType,
            behaviorType,
            params
        ]);
    },
    sidebarBehaviorAssesments: (behaviorId, targetId, targetType, params) => {
        return (0, compact_1.default)([
            ...defaultKey,
            'behavior-sidebar',
            behaviorId,
            targetId,
            targetType,
            params
        ]);
    },
    comparatorEmployee: (params) => {
        return (0, compact_1.default)([...defaultKey, 'employee', params]);
    },
    comparatorGroup: (params) => {
        return (0, compact_1.default)([...defaultKey, 'group', params]);
    },
    comparisonGoalAssesments: (targetType, targetId, params) => {
        return (0, compact_1.default)([...defaultKey, targetType, targetId, params]);
    },
    comparisonGoalAssesmentsList: (targetType, targetId, params) => {
        return (0, compact_1.default)([
            ...defaultKey,
            'goal-assesments',
            targetType,
            targetId,
            params
        ]);
    },
    comparisonGoalAssesmentsDetail: (objectiveId) => {
        return (0, compact_1.default)([...defaultKey, 'goal-assesment', objectiveId]);
    },
    comparisonPerformanceAssesments: (targetId, targetType, cycleId, params) => {
        return (0, compact_1.default)([
            ...defaultKey,
            'performance',
            targetId,
            targetType,
            cycleId,
            params
        ]);
    },
    cycleSources: (params) => {
        return (0, compact_1.default)([...defaultKey, 'cycle-sources', params]);
    },
    comparisonCalibrationHistories: (cycleId, targetId, params) => {
        return (0, compact_1.default)([
            ...defaultKey,
            'calibration-histories',
            cycleId,
            targetId,
            params
        ]);
    }
};
exports.default = keys;
